import { lazy, Suspense } from 'react';
import type { ReactNode, ComponentType } from 'react';
import PageLoading from '@classify/react-core-components/PageLoading';

type Loader = () => Promise<{ default: ComponentType<any> }>;

export default function getLoadableModule(loader: Loader, fallback: ReactNode = <PageLoading />) {
  const LazyComponent = lazy(loader);

  return (props: any = {}) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
}
